import script from "./PromptFeedbackTriage.vue?vue&type=script&setup=true&lang=js"
export * from "./PromptFeedbackTriage.vue?vue&type=script&setup=true&lang=js"

import "./PromptFeedbackTriage.vue?vue&type=style&index=0&id=e21e67fe&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e21e67fe"]])

export default __exports__